import { IComponentOptions } from "angular";
import { MachinesEditController } from "./controller";
export const vsComponentName = "machineDetailMachinesEdit";
export const MachineDetailMachinesEditComponentOptions: IComponentOptions = {
  controller: MachinesEditController,
  template: require("!html-loader!./index.html").default,
  controllerAs: "stateController",
  bindings: {
    contractMachines: "<",
    contractId: "<",
  },
};
